import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=54dfd5b3&scoped=true"
import script from "./examination.vue?vue&type=script&lang=js"
export * from "./examination.vue?vue&type=script&lang=js"
import style0 from "./examination.vue?vue&type=style&index=0&id=54dfd5b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfd5b3",
  null
  
)

export default component.exports